var _defs, _ellipse, _ellipse2, _ellipse3, _g, _path, _g2, _g3, _g4, _use, _use2, _use3, _use4, _path2, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreboundFracturedCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 900",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "aura"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#10283F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#225B80",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2C426D",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#081122",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#53D9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#267C9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#472E70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131B37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icePlate",
    x1: 295,
    y1: 130,
    x2: 620,
    y2: 680,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31485B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#122639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#070E1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2D47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "violetPlate",
    x1: 900,
    y1: 200,
    x2: 580,
    y2: 650,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1B1933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#090F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26334C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "seam",
    x1: 430,
    y1: 130,
    x2: 775,
    y2: 710,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#4CCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#D4D5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A371DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orbit",
    x1: 120,
    y1: 360,
    x2: 1080,
    y2: 460,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58DAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#58DAFF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#B6F4FF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#B686FF",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B686FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "seamGlow",
    x: "-25%",
    y: "-20%",
    width: "150%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  })), /*#__PURE__*/React.createElement("filter", {
    id: "haze",
    x: "-45%",
    y: "-45%",
    width: "190%",
    height: "190%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26
  })), /*#__PURE__*/React.createElement("path", {
    id: "cracks",
    d: "M574 77 561 148 587 205 565 266 596 324 578 373 616 419 590 480 626 534 611 591 644 652 628 719 M587 205 658 225 703 207 755 239 819 210 M565 266 492 285 456 260 399 288 321 272 M578 373 510 399 478 449 417 460 353 509 M616 419 672 393 710 429 775 416 851 455 M626 534 689 554 716 610 769 632 M510 399 493 350 446 337 M710 429 725 480 782 498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rim",
    d: "M541 78 477 96 419 128 359 183 321 249 295 318 289 385 307 455 335 514 384 575 449 640 519 685 582 710 640 719 710 694 776 654 827 602 871 533 902 466 916 398 908 326 882 256 841 196 780 142 715 104 646 81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shard",
    d: "m0-28 25 18-8 40-30-8-9-30Z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 400,
    rx: 510,
    ry: 430,
    fill: "url(#aura)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 490,
    cy: 355,
    rx: 242,
    ry: 285,
    fill: "#1D86A3",
    opacity: 0.12,
    filter: "url(#haze)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 771,
    cy: 456,
    rx: 177,
    ry: 244,
    fill: "#8A4BC9",
    opacity: 0.14,
    filter: "url(#haze)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-22 600 404)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 404,
    rx: 485,
    ry: 158,
    stroke: "url(#orbit)",
    strokeWidth: 10,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 404,
    rx: 485,
    ry: 158,
    stroke: "url(#orbit)",
    strokeWidth: 1.5,
    strokeDasharray: "390 25 170 90 290 34"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 600,
    cy: 404,
    rx: 505,
    ry: 171,
    stroke: "url(#orbit)",
    strokeWidth: 0.7,
    opacity: 0.4,
    strokeDasharray: "3 17"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M574 77 477 96 419 128 359 183 321 249 295 318 289 385 307 455 335 514 384 575 449 640 519 685 582 710 628 719 710 694 776 654 827 602 871 533 902 466 916 398 908 326 882 256 841 196 780 142 715 104 646 81Z",
    fill: "url(#heart)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#6399B5",
    strokeOpacity: 0.18,
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m565 73-15 76 26 56-22 52-60 17-36-27-61 29-78-13 31-72 57-63 67-39Z",
    fill: "url(#icePlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591 76 56 7 70 25 62 39 57 52-18 2-62 27-51-34-45 19-64-18-24-49Z",
    fill: "url(#violetPlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315 286 82 16 58-28 34 27 65-19 29 44-16 40-65 25-33 49-56 8-61 48-39-61-16-55 8-67Z",
    fill: "url(#icePlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607 217 51 21 47-15 50 30 71-29 43 41 26 65 8 67-8 44-42-1-76-37-63 12-39-37-52 27-29-35 17-47-29-60Z",
    fill: "url(#violetPlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353 523 68-48 64-13 34-49 48-23 30 30-19 60 35 57-13 54 32 64-14 51-35-4-58-23-68-45-65-61Z",
    fill: "url(#icePlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632 430 40-23 35 36 66-14 72 41 48-11-19 68-41 67-57 55-55 36-66 23-9-57-23-59 12-59-34-54Z",
    fill: "url(#violetPlate)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#89BED2",
    opacity: 0.045
  }, /*#__PURE__*/React.createElement("path", {
    d: "m350 191 144 83-97 2-78-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315 286 187 105-89 57-61 48-39-61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353 523 214-133-120 244-55-61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m607 217 219 7 69 106-153-54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632 430 201 164-57 55-121 59Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7893B0",
    strokeOpacity: 0.14,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m404 180 67-45 58-20m-177 202-18 61 22 64m69 112 45 43 68 40m135-502 63 25 52 41m68 147 8 49-14 46m-64 105-35 38-63 38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417 189 57-37 31-8m-137 180-15 52 13 36m71 135 38 36 51 28m153-459 50 19 39 31m60 142 6 34-8 25m-65 111-28 30-49 29"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#rim",
    stroke: "url(#seam)",
    strokeWidth: 7,
    opacity: 0.2,
    filter: "url(#seamGlow)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#rim",
    stroke: "url(#seam)",
    strokeWidth: 1.5,
    opacity: 0.55,
    strokeDasharray: "170 24 85 19 210 45"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#cracks",
    stroke: "url(#seam)",
    strokeWidth: 13,
    opacity: 0.55,
    filter: "url(#seamGlow)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#cracks",
    stroke: "url(#seam)",
    strokeWidth: 2.5,
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m574 77-13 71 26 57-22 61 31 58-18 49 38 46-26 61 36 54-15 57 33 61-16 67",
    stroke: "#D4F7FF",
    strokeWidth: 1,
    opacity: 0.62
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "url(#seam)",
    strokeOpacity: 0.48,
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m467 57 52-15 24 14-21 22-45 5Z",
    fill: "url(#icePlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m728 81 43 4 41 33-14 20-38-25Z",
    fill: "url(#violetPlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 282 17 35-10 51-17-14-12-35Z",
    fill: "url(#icePlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m939 379 18 20-13 64-21 8 9-51Z",
    fill: "url(#violetPlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437 672 56 34 27 37-35-7-57-44Z",
    fill: "url(#icePlate)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m666 739 58-21 36-1-20 25-52 23Z",
    fill: "url(#violetPlate)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-22 600 404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 425c19 82 215 139 441 137m93-2c102-7 193-27 264-55",
    stroke: "url(#orbit)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 432c34 75 210 127 395 132m199-13c70-9 143-27 190-45",
    stroke: "url(#orbit)",
    strokeWidth: 0.7,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149 469-5 10m52 17-4 10m756-21 5 10m36-31 7 10",
    stroke: "url(#seam)",
    strokeWidth: 3,
    opacity: 0.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#3C7089",
    stroke: "#87CDE1",
    strokeOpacity: 0.36
  }, /*#__PURE__*/React.createElement("use", {
    href: "#shard",
    transform: "translate(231 158) rotate(-28) scale(.6)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#shard",
    transform: "translate(969 234) rotate(42) scale(.8)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#shard",
    transform: "translate(254 612) rotate(19) scale(.7)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#shard",
    transform: "translate(881 720) rotate(-34) scale(.95)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#shard",
    transform: "translate(366 780) rotate(62) scale(.4)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#shard",
    transform: "translate(731 823) rotate(-22) scale(.3)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#9CDAEC",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 308,
    cy: 100,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 66,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 230,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 402,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228,
    cy: 492,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318,
    cy: 678,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 793,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 547,
    cy: 826,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 687,
    cy: 797,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 799,
    cy: 761,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 945,
    cy: 649,
    r: 1.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982,
    cy: 548,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1001,
    cy: 347,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 919,
    cy: 165,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 816,
    cy: 66,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 646,
    cy: 37,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreboundFracturedCore);
export default __webpack_public_path__ + "static/media/coreboundFracturedCore.7620f1eb1aabdc3eb3b58de192e36b82.svg";
export { ForwardRef as ReactComponent };